import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { ArrowsMain, TestQuate } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

function Equitrip() {
  return (
    <Container className="h-100">
      <Row className="h-100">
        <Col
          xs={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className="tekrevol_project_item"
        >
          <div
            className="teemates_project"
            style={{ background: "rgb(255, 255, 255)" }}
          >
            <Row>
              <Col xs={12} md={10} lg={6} xl={6} xxl={6}>
                <div className="project_info">
                  <div className="logo_project">
                    <StaticImage
                      src="../../images/equitrip/amj-logo.webp"
                      alt="tekrevol_Casestudy"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={175}
                      height={90}
                    />
                  </div>
                  <div className="framework_project">
                    <ul style={{ color: "rgb(157, 19, 23)" }}>
                      <li>IOS APP</li>
                      <li>Android App</li>
                      <li>Web App</li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={2} lg={6} xl={6} xxl={6}>
                <div
                  className="project_statistics"
                  style={{ color: "rgb(157, 19, 23)" }}
                ></div>
              </Col>
              <Col xs={12} md={12} lg={12} xl={11} xxl={11}>
                <div
                  className="project_title"
                  style={{ color: "rgb(40, 35, 29)" }}
                >
                  <h2 style={{ color: "rgb(40, 35, 29)" }}>
                    The Idea Behind AMJ Wellness
                  </h2>
                  <p>
                    The app had to have an interface, super-friendly and less
                    distracting for corporate employees who already have
                    stressful jobs. It had to be feature-packed and targeted at
                    promoting wellness actions including drinking enough water,
                    exercising, taking time off the screens, participating in
                    workouts, and eating healthy breakfasts, lunches, and
                    dinners. We performed meticulous research on the target
                    market, projected users, and the overall scope of the
                    project.
                  </p>
                </div>
              </Col>
            </Row>
            <div className="img_boxing">
              <StaticImage
                src="../../images/equitrip/Home-Banner.webp"
                alt="tekrevol_Casestudy"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1436}
                height={495}
              />
            </div>
          </div>
        </Col>
        <Col
          xs={12}
          md={9}
          lg={7}
          xl={6}
          xxl={6}
          className="m-auto tekrevol_project_review"
        >
          <div className="project_review">
            <p>
              “They love creating apps to help better the world, help better the
              society, so they immediately had a connection with my idea."
              {TestQuate}
            </p>
            <div className="review_info">
              <div className="preson">
                <StaticImage
                  src="../../images/equitrip/amj_owner.webp"
                  alt="tekrevol_android"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="preson_info">
                <h6>Andrea Eimers</h6>
                <div className="designation">
                  AMJ Wellness , Co-Founder & COO
                </div>

                <div className="project_link">
                  <Link
                    to="/case-studies/amj-wellness"
                    aria-label="TekRevol amj-wellness"
                  >
                    Full Case Study
                    {ArrowsMain}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Equitrip;
